import { SocialUser } from '@abacritt/angularx-social-login';
import { IGeoip } from './events.interfaces';
import { TLang } from './types';
import { IUser } from './user.interfaces';
import { ITokens } from './auth.interfaces';

export interface ISignProvider extends Partial<SocialUser> {
  email: string;
  firstName: string;
  id: string;
  idToken?: string;
  lastName: string;
  name: string;
  photoUrl: string;
  provider: SIGN_PROVIDERS.GOOGLE;
  //
  lang?: TLang;
  ip?: string;
  geoip?: IGeoip;
  country?: string;
  referral?: string;
  deviceId?: string;
}

export enum SIGN_PROVIDERS {
  GOOGLE = 'GOOGLE',
  TELEGRAM = 'TELEGRAM',
}
export interface ITelegramProvider {
  provider: SIGN_PROVIDERS.TELEGRAM;
  id: number;
  first_name?: string;
  last_name?: string;
  username?: string;
  photo_url?: string;
  auth_date: number;
  hash: string;
  phone_number?: string;
  //
  domain?: string;
  lang?: TLang;
  ip?: string;
  geoip: IGeoip;
  country?: string;
  referral?: string;
  deviceId?: string;
}
